<template>
  <div class="u-analysis-detail">
    <div class="row">
      <div class="item">
        <span class="label label2">药品名称</span>
        <!-- <span class="value">{{ info.drugName }}</span> -->
        <span class="value">
          <span class="name">{{ info.drugName }}</span>
          <span class="red" v-if="info.drugDosingOrReduce">
            {{ info.drugDosingOrReduce == 1 ? "（加药）" : "（删药）" }}
          </span>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <span class="label label2">禁忌</span>
        <span class="value">{{ info.taboo }}</span>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <span class="label label2">归经</span>
        <span class="value">{{ info.channelTropism }}</span>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <span class="label label2">功效</span>
        <span class="value">{{ info.effect }}</span>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <span class="label label2">错误原因</span>
        <span class="value">{{ info.reason }}</span>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <span class="label label2">是否为告知后的同样错误</span>
        <span class="value">{{ info.sameError ? "是" : "否" }}</span>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <span class="label label2">医生本人回复</span>
        <span class="value" v-if="info.auditStage != 1">{{ doctorReply }}</span>
      </div>
    </div>
    <div class="row" v-if="isShowCommitteeReply1">
      <div class="item">
        <span class="label label2">医生委员会回复</span>
        <span
          class="value"
          v-if="isShowCommitteeReply2"
          v-html="committeeReply"
        >
        </span>
      </div>
    </div>

    <div class="row" v-if="info.auditStage > 2">
      <div class="item">
        <span class="label label2">最终审核结果</span>
        <span class="value" v-if="finalResult">
          <span>{{ finalResult }}</span>
        </span>
      </div>
    </div>

    <div class="f_item" v-if="info.auditStage == auditStage && !isReplied">
      <FormItem
        label="是否同意错误原因"
        :prop="'items.' + index + '.auditResult'"
        :rules="{
          required: true,
          message: '请选择是否同意错误原因',
          trigger: 'change',
        }"
      >
        <RadioGroup v-model="info.auditResult">
          <Radio label="1"
            >同意{{ info.auditStage == 2 ? "检视结果反对医生用药" : "" }}</Radio
          >
          <Radio label="2"
            >反对{{ info.auditStage == 2 ? "检视结果同意医生用药" : "" }}</Radio
          >
        </RadioGroup>
      </FormItem>
      <FormItem
        v-if="info.auditResult == '2'"
        label="反对原因"
        :prop="'items.' + index + '.auditReason'"
        :rules="{
          required: true,
          message: '请输入反对原因',
          trigger: 'blur',
        }"
      >
        <Input
          type="textarea"
          v-model="info.auditReason"
          placeholder="请输入"
        ></Input>
      </FormItem>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    auditStage: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    isReplied: {
      //是否已回复
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 医生本人回复信息
    doctorReply() {
      let item = this.info.records.find((i) => i.auditorType == 1);
      return item ? this.auditResultToStr(item) : "未回复";
    },
    // 是否显示医生委员会回复标题
    isShowCommitteeReply1() {
      let item = this.info.records.find((i) => i.auditorType == 1);
      return item && item.auditResult == 2; //医生本人不同意才显示医生委员会回复的conten
    },
    // 是否显示医生委员会回复信息
    isShowCommitteeReply2() {
      let item = this.info.records.find((i) => i.auditorType == 1);
      // 是否委员会全回复过了
      let isAllAnswer = this.info.records
        .filter((i) => i.auditorType == 2)
        .every((i) => i.auditResult);
      return item && item.auditResult == 2 && (isAllAnswer || this.isReplied); //医生本人不同意才显示医生委员会回复的conten
    },
    // 医生委员会回复信息
    committeeReply() {
      let item = this.info.records.filter((i) => i.auditorType == 2);
      if (item.length) {
        let arrList = [];
        item.forEach((i) => {
          let str = this.auditResultToStr(i, true);
          arrList.push(`<div>${i.auditorName}：${str}</div>`);
        });
        return arrList.join("");
      } else {
        return "未回复";
      }
    },
    // 最终审核结果
    finalResult() {
      /*
      1、医生本人在回复时间范围内同意的，备注写“医生本人同意”
      2、医生本人超时系统自动同意的，进入最终审核
      3、医生本人反对，医术委员会一致同意的，进入最终审核
      4、医生本人反对，医术委员会一致反对的，最终审核结果自动同意，备注写“医术委员会一致反对”
      5、医生本人反对，医术委员会回复不一致的，最终审核结果是最终审核操作人录入的结果
      */
      let item = this.info.records.find((i) => i.auditorType == 1);
      let item4 = this.info.records.find((i) => i.auditorType == 4);
      if (item && item.auditResult == 1 && item4?.auditorId == -1) {
        return "医生本人同意检视结果";
      } else if (this.info.auditStage == 3) {
        let item2 = this.info.records.find((i) => i.auditorType == 3);
        return item2 ? this.auditResultToStr(item2, true) : "";
      } else {
        let arr = this.info.records.filter((i) => i.auditorType == 2);
        if (arr.length) {
          if (arr.every((i) => i.auditResult == 1)) {
            return "医术委员会一致同意检视结果";
          } else if (arr.every((i) => i.auditResult == 2)) {
            return "医术委员会一致反对检视结果";
          } else {
            return "";
          }
        } else {
          return "";
        }
      }
    },
  },
  methods: {
    auditResultToStr(item, isFinalJudgment) {
      let str = "";
      switch (item.auditResult) {
        case 0:
          str = "未回复";
          break;
        case 1:
          str = `${
            isFinalJudgment ? "同意检视结果反对医生用药" : "同意检视结果"
          }；${item.auditReason || ""}`;
          break;
        case 2:
          str = `${
            isFinalJudgment ? "反对检视结果同意医生用药" : "反对检视结果"
          }；${item.auditReason || ""}`;
          break;
      }
      return str;
    },
    onEdit() {},
  },
};
</script>

<style scoped lang="scss">
.u-analysis-detail {
  :deep {
    .addwin {
      .footer {
        display: block;
      }
    }
    .ivu-radio-wrapper {
      margin-right: 30px;
    }
  }
  .drug-name {
    padding-bottom: 20px;
    span {
      display: inline-block;
    }
    .label {
      width: 100px;
      padding-right: 5px;
    }
  }
  .f_item {
    margin-top: 5px;
    border-radius: 5px;
    padding: 5px 15px 5px;
    background: #fff;
    .ivu-form-item {
      margin-bottom: 10px;
    }
  }
}
</style>
